export const GenerateUID = {

	/*
	**  Set the methods
	*/

	methods: {

		generateUID: function() {

			return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

		}

	}

}